import axiosInstance from '../../../helpers/backend_helper';

const createStory = async (title, description, type, coverImage, audioLink, videoLinkString, storyText) => {
  try {
    const formData = new FormData();
    formData.append('name', title);
    formData.append('excerpt', description);
    formData.append('type', type);
    formData.append('image', coverImage);

    const response = await axiosInstance.post('stories', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error creating book:', error);
    throw error;
  }
};

export default createStory;
